import { render, staticRenderFns } from "./EditPostOptions.vue?vue&type=template&id=f5912148&scoped=true&"
import script from "./EditPostOptions.vue?vue&type=script&lang=ts&"
export * from "./EditPostOptions.vue?vue&type=script&lang=ts&"
import style0 from "./EditPostOptions.vue?vue&type=style&index=0&id=f5912148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5912148",
  null
  
)

export default component.exports